import React from 'react';
import SEO from '../components/ui/SEO';
import { Link } from 'react-router-dom';
export default function Sitemap() {
  const sections = [{
    title: 'Main Pages',
    links: [{
      label: 'Home',
      path: '/'
    }, {
      label: 'About Dr. Syed',
      path: '/about'
    }, {
      label: 'Contact Us',
      path: '/contact'
    }, {
      label: 'FAQs',
      path: '/faq'
    }]
  }, {
    title: 'Our Services',
    links: [{
      label: 'All Services',
      path: '/services'
    }, {
      label: 'Mental Capacity Assessments',
      path: '/services/mental-capacity'
    }, {
      label: 'Trauma & PTSD Evaluations',
      path: '/services/trauma-ptsd'
    }, {
      label: 'Neurodevelopmental Assessments (ADHD & ASD)',
      path: '/services/neurodevelopmental'
    }, {
      label: 'Forensic & Risk Assessments',
      path: '/services/forensic-risk'
    }, {
      label: 'Specialist Psychiatric Evaluations',
      path: '/services/specialist'
    }, {
      label: 'Clinical Negligence Cases',
      path: '/services/clinical-negligence'
    }]
  }, {
    title: 'Policies',
    links: [{
      label: 'Privacy & Cookie Policy',
      path: '/policies/privacy'
    }, {
      label: 'Terms & Conditions',
      path: '/policies/terms'
    }, {
      label: 'Cancellation Policy',
      path: '/policies/cancellation'
    }]
  }];
  return <main className="min-h-screen bg-white" data-id="element-1422" data-mp="2fyzv6u5lagf1">
      <SEO title="Sitemap | All Pages | Medicolegal Psychiatry" description="Browse every page on the Medicolegal Psychiatry site, including all expert witness services and policies. Find what you need and get in touch." path="/sitemap" imageAlt="Index of all pages on the Medicolegal Psychiatry site" data-id="element-1423" data-mp="3chnmx81g12cm" />

      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-1424" data-mp="1arq6o0n1pl0c">
        <div className="container mx-auto px-4" data-id="element-1425" data-mp="w2kcir32ekzb">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-center" data-id="element-1426" data-mp="w1ra22b52hmz">
            Sitemap
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-center mt-4" data-id="element-1427" data-mp="n2dzt7f6xp17">
            A complete overview of all pages on our website
          </p>
        </div>
      </section>

      {/* Sitemap Content */}
      <section className="py-12" data-id="element-1428" data-mp="d59f7c0zu1mi">
        <div className="container mx-auto px-4" data-id="element-1429" data-mp="d6aphea6qk36">
          <div className="max-w-3xl mx-auto" data-id="element-1430" data-mp="i3kkrak99pyx">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-1431" data-mp="i4chiopl9tqs">
              {sections.map(section => <div key={section.title} data-id="element-1432" data-mp="27gxw3jqsce9j">
                  <h2 className="text-xl font-serif font-bold text-primary mb-4 pb-2 border-b-2 border-secondary" data-id="element-1433" data-mp="2ci3lp8p5fleu">
                    {section.title}
                  </h2>
                  <ul className="space-y-3" data-id="element-1434" data-mp="3s12y8l3zrmco">
                    {section.links.map(link => <li key={link.path} data-id="element-1435" data-mp="ak1lruum9m4p">
                        <Link to={link.path} className="text-slate-dark hover:text-primary hover:underline transition-colors duration-200" data-id="element-1436" data-mp="al35sotm1iyk">
                          {link.label}
                        </Link>
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </main>;
}